import React from 'react';
import { DeleteWarning, Buttons, ModalContent } from './styles';
import Button from '../../button';
import { BUTTON_TYPE } from '../../../global/constants';
import ModalHeader from '../modalHeader';

interface UserData {
  onOk?: (e: React.SyntheticEvent) => void;
  onClose?: () => void;
  loading?: boolean;
  modalTitle?: string;
  description?: string;
  isYes?: boolean;
  isArchive?: boolean;
  isPrimaryButton?: boolean;
  buttonText?: string;
}

const DeleteModal: React.FC<UserData> = (props) => {
  return (
    <>
      <ModalHeader title={props.modalTitle} onClose={props.onClose} />
      <ModalContent>
        <DeleteWarning>{props.description}</DeleteWarning>
        <Buttons>
          <Button
            title='Cancel'
            onClick={props.onClose}
            buttonType='button'
            variant={BUTTON_TYPE.SECONDARY}
            size='medium'
          />
          <Button
            title={props.buttonText || (props.isYes ? 'Yes' : props.isArchive ? 'Archive' : 'Delete')}
            variant={props.isYes || props.isArchive ? BUTTON_TYPE.PRIMARY : BUTTON_TYPE.CRITICAL}
            isLoading={props.loading}
            size='medium'
            onClick={props.onOk}
          />
        </Buttons>
      </ModalContent>
    </>
  );
};

export default DeleteModal;
